<template>
  <div class="product__bundle">
    <div class="grid-x" v-if="availableOptions.length > 0">
      <component v-for="bundleOption in availableOptions" :is="`catalog-product-bundle-${bundleOption.type}`" :bundle-option="bundleOption" :key="bundleOption.option_id"/>
    </div>
    <span class="_error" v-else>{{ $t('There are no available options for this product.') }}</span>
  </div>
</template>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component(
    {
      name: 'catalog-product-bundle',
      components: {
        'catalog-product-bundle-select': ServiceContainer().getComponent('catalog-product-bundle-select'),
        'catalog-product-bundle-radio': ServiceContainer().getComponent('catalog-product-bundle-radio'),
        'catalog-product-bundle-checkbox': ServiceContainer().getComponent('catalog-product-bundle-checkbox')
      }
    }
  )

  export default class extends Vue {
    private get availableOptions(): Array<object> {
      return this.$store.getters['CatalogBundleProduct/availableOptions'];
    }
  }
</script>
